import { BaseAudioRecordingAppEventOperation } from "./BaseAudioRecordingAppEventOperation";
import { AudioRecordingAppEventOperationKind } from "@/store/sync/operations/types";

export class MarkTranscriptionDisconnectedAudioRecordingOperation extends BaseAudioRecordingAppEventOperation {
  get operationKind(): AudioRecordingAppEventOperationKind {
    return "MARK_TRANSCRIPTION_DISCONNECTED_AUDIO_RECORDING";
  }

  // Transcription disconnect doesn't change model status fields
  // The event is tracked for observability purposes
}
